module.exports = __webpack_public_path__ + "static/media/broadcast-icon.4954fd18.svg";